module.exports = __webpack_public_path__ + "05056aea302f146cc80b2c8b63bba84c.png";